import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function Licenses() {
  return (
    <>
      <Header />
      
      <section className="licenses-section">
        <div className="container">
          <h1 className="licenses-title">
            <span className="licenses-title-line-1">LICENSES</span>
          </h1>
          
          <div className="licenses-content">
            <p className="licenses-description">
              All images and design assets used in this portfolio are created by Ansh Chopra or used with proper authorization from clients and projects. The work showcased represents real client projects and personal design explorations.
            </p>
          </div>

          <div className="licenses-collage">
            <div className="collage-item">
              <img src="/assets/solo-beauty-first.png" alt="Solo Beauty Design" />
            </div>
            <div className="collage-item">
              <img src="/assets/flash-delivery-first.png" alt="Flash Delivery" />
            </div>
            <div className="collage-item">
              <img src="/assets/liveasy-first.png" alt="Liveasy Logo" />
            </div>
            <div className="collage-item">
              <img src="/assets/personal-first.jpeg" alt="Personal Work" />
            </div>
            <div className="collage-item">
              <img src="/assets/solo-beauty-second.png" alt="Solo Beauty UI" />
            </div>
            <div className="collage-item">
              <img src="/assets/flash-delivery-cover.jpeg" alt="Flash Delivery Cover" />
            </div>
            <div className="collage-item">
              <img src="/assets/liveasy-second.png" alt="Liveasy Design" />
            </div>
            <div className="collage-item">
              <img src="/assets/personal-second.jpeg" alt="Personal Design" />
            </div>
          </div>

          <div className="licenses-footer-text">
            <h3>Copyright & Usage</h3>
            <p>© 2024 Ansh Chopra. All rights reserved. The designs, images, and content displayed on this portfolio are the intellectual property of Ansh Chopra and respective clients. Unauthorized use, reproduction, or distribution of these materials is strictly prohibited without prior written consent.</p>
            
            <h3>Client Projects</h3>
            <p>Projects displayed for Solo Beauty, Flash Delivery, Liveasy, and other clients are showcased with permission and represent work completed under professional agreements. These materials are used solely for portfolio demonstration purposes.</p>
            
            <h3>Personal Work</h3>
            <p>All personal design explorations and experimental work are original creations by Ansh Chopra and are protected under copyright law.</p>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Licenses;
